/* @ngInject */
function CampaignDashboardController ($rootScope, $scope, $translate, $stateParams, $window, $timeout, AnalyticsService, ToastService, SegmentService) {
  $scope.slug = 'campaigns-dashboard'

  $scope.flags = {
    loading: false
  }

  $scope.analyticsProps = {
    params: {
      filtersLoaded: true,
      calendar: {
        start: $scope.campaign.startDate,
        end: $scope.campaign.deliveryDate,
        mixpanel: ''
      },
      campaignId: $scope.campaign.id
    },
    loading: {
      barChart: false,
      card: false,
      lineChart: false,
      groupedDonut: false
    }
  }

  $scope.dataFrames = []
  $scope.generateSpreadsheet = false

  const api = {
    _getDataFrames,
    _successGetDataFrames,
    _errorGetDataFrames,
    _finallyGetDataFrames,
    _successGetDataPageSpreadsheet,
    _errorGetDataPageSpreadsheet,
    _formatDateFromString
  }

  this.getApi = () => api

  activate()
  function activate () {
    if ($stateParams.id) {
      api._getDataFrames()
    }
  }

  $scope.downloadSpreadsheet = () => {
    const timeZone = $rootScope.oUser.locale ? new Intl.DateTimeFormat($rootScope.oUser.locale).resolvedOptions().timeZone : ''
    const filterParams = $scope.analyticsProps.params
    const params = {
      ...filterParams,
      start: filterParams.calendar.start,
      end: filterParams.calendar.end,
      timeZone,
      calendar: null,
      allFilters: null
    }

    AnalyticsService.getDataPageSpreadsheet($scope.slug, params)
      .then(api._successGetDataPageSpreadsheet)
      .catch(api._errorGetDataPageSpreadsheet)
  }

  async function _getDataFrames () {
    try {
      $scope.flags.loading = true

      const response = await AnalyticsService.getPageComponentsByPageId($scope.slug)

      api._successGetDataFrames(response)
    } catch (error) {
      api._errorGetDataFrames(error)
    } finally {
      api._finallyGetDataFrames()
    }
  }

  function _successGetDataFrames (response) {
    $scope.dataFrames = response.dataFrames.filter(dataFrame => dataFrame.chartType !== 'CARD')
    $scope.dataFrameCards = response.dataFrames.filter(dataFrame => dataFrame.chartType === 'CARD')
    $scope.generateSpreadsheet = response.generateSpreadsheet
  }

  function _errorGetDataFrames (error) {
    console.error(error)
    $scope.dataFrameCards = []
    $scope.dataFrames = []
    ToastService.defaultErrorToast()
  }

  function _finallyGetDataFrames () {
    $timeout(() => {
      $scope.flags.loading = false
    })
  }

  function _successGetDataPageSpreadsheet () {
    const { calendar: { start, end } } = $scope.analyticsProps.params

    const successMessageDownload = $translate.instant('requestingReportDescription', {
      startDate: api._formatDateFromString(start, $rootScope.oUser.locale),
      endDate: api._formatDateFromString(end, $rootScope.oUser.locale)
    })

    SegmentService.track('analytics-download-csv', {
      data_page: $scope.slug
    })

    if (window.clarity) {
      window.clarity('set', 'analytics-download-csv', $scope.slug)
    }

    ToastService.showSuccessToast(successMessageDownload)
  }

  function _errorGetDataPageSpreadsheet () {
    ToastService.showErrorToast($translate.instant('somethingWentWrongTryAgainMsg'))
  }

  function _formatDateFromString (date, locale) {
    return new Intl.DateTimeFormat(locale).format(new Date(date))
  }
}

export { CampaignDashboardController }
